<div *ngIf="isVisible" class="modal-overlay">
  <div class="modal-container">
    <button type="button" class="close-button" (click)="onDiscard()">×</button>

    <div class="modal-header">
      <div class="icon-container">
        <span [innerHTML]="renderIcon()"></span>
      </div>
    </div>

    <div class="modal-content">
      <h3>{{ title }}</h3>

      <div class="modal-body-content">
        <p *ngIf="description; else htmlDescription" class="confirm-text">
          {{ description }}
        </p>

        <ng-template #htmlDescription>
          <p class="confirm-text" [innerHTML]="descriptionHtml"></p>
        </ng-template>
        <ng-content />
      </div>
    </div>

    <div class="modal-actions">
      <button type="button" class="save-button" (click)="onSave()">
        {{ confirmButtonText }}
      </button>
      <button type="button" class="discard-button" (click)="onDiscard()">
        {{ cancelButtonText }}
      </button>
    </div>
  </div>
</div>
